import {load} from '@shopify/theme-sections';

import {updateWishlistURL, initWishlistProductForms} from '../utils/wishlist';

const template = 'page.swym';

export default (function () {
  if (document.body.dataset.template !== template) return;

  load('*');

  updateWishlistURL();
})();

window.addEventListener('DOMContentLoaded', function () {
  initWishlistProductForms();
});
